import * as React from 'react';


import { useAppContext } from '../../contexts/AppContext';
import { Button, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import Image, { ImageLoaderProps } from 'next/image';
import styled from '@emotion/styled';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from '../Link';

const TapMenuContainer = styled('div')(() => ({
  position: 'absolute',
  left: '-12px',
  zIndex: 5,
  bottom: '40px',
  transition: '0.24s'
}));

const StyledListItemButton = styled(ListItemButton)(() => ({
  border: '1px solid #bdbdbd',
  marginBottom: '12px',
  background: 'white',
  '&:hover': {
    background: '#fafafa',
  },
}));

const TapMenuLinkContainer = styled('span')(() => ({
  color: '#464646',
  width: '100%',
}));


const TapMenu = () => {
  const [open, setOpen] = React.useState<boolean | undefined>();

  const appContext = useAppContext();
  const { componentOptions } = appContext.useConfig();

  const tapMenuList = componentOptions?.component_tapmenu_list;
  const tapMenuVisible = componentOptions?.component_tapmenu_show;

  if (tapMenuVisible && Array.isArray(tapMenuList))
    return (
      <>
        <TapMenuContainer style={{ left: open ? 'calc(50% - 12px)' : '-12px' }}>
          <Button onClick={() => setOpen((prevState) => !prevState)}>
            <Image
              src="/images/game_tap_menu.png"
              loader={({ src }: ImageLoaderProps) => src}
              alt="game_tap_menu"
              height="40"
              width="40"
            />
          </Button>
        </TapMenuContainer>
        <Drawer
          open={open}
          variant="persistent"
          anchor="left"
          PaperProps={{
            sx: { width: '50%', background: '#ebebeb' },
          }}
          sx={{
            '& .MuiDrawer-root': {
              position: 'absolute',
            },
            '& .MuiPaper-root': {
              position: 'absolute',
            },
          }}
        >
          <List>
            {tapMenuList.map(({ title, href }) => (
              <ListItem component={Link} href={href} key={title} disablePadding>
                <StyledListItemButton>
                  <TapMenuLinkContainer>{title}</TapMenuLinkContainer>
                  <KeyboardArrowRightIcon style={{ fill: '#32acff' }} />
                </StyledListItemButton>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </>
    )
  return <></>
};

export default TapMenu;
